import { useState, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import PortalPopup from "../../components/PortalPopup";
import DownloadModalTables from "../../components/DownloadModalTables";
import ClaimIdFilter from "../../components/ClaimIdFilter";
import LawFirm from "../../components/LawFirm";
import NavigationPanel from "../../components/NavigationPanel";
import CTAs from "../../components/CTAs";
import Footer from "../../components/Footer";

const OutcomeAndCostPage_3 = () => {
  const navigate = useNavigate();
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);
  const [isDownloadModalTablesOpen, setDownloadModalTablesOpen] =
    useState(false);
  const [isClaimIdFilterOpen, setClaimIdFilterOpen] = useState(false);
  const [isLawFirmOpen, setLawFirmOpen] = useState(false);
  const [isLawFirm1Open, setLawFirm1Open] = useState(false);
  const [isLawFirm2Open, setLawFirm2Open] = useState(false);
  const [isLawFirm3Open, setLawFirm3Open] = useState(false);
  const [isLawFirm4Open, setLawFirm4Open] = useState(false);
  const [isLawFirm5Open, setLawFirm5Open] = useState(false);
  const [isLawFirm6Open, setLawFirm6Open] = useState(false);
  const [isLawFirm7Open, setLawFirm7Open] = useState(false);
  const [isLawFirm8Open, setLawFirm8Open] = useState(false);
  const [isLawFirm9Open, setLawFirm9Open] = useState(false);

  const onClickOutcomeUpdates = useCallback(() => {
    navigate("/outcome&cost");
  }, [navigate]);

  const onClickCostImplications = useCallback(() => {
    navigate("/outcome&cost2");
  }, [navigate]);

  const onClickClientCommunication = useCallback(() => {
    navigate("/outcome&cost4");
  }, [navigate]);

  const onClickReportAndAnalytics = useCallback(() => {
    navigate("/outcome&cost5");
  }, [navigate]);

  const openLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(true);
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const openDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(true);
  }, []);

  const closeDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(false);
  }, []);

  const openClaimIdFilter = useCallback(() => {
    setClaimIdFilterOpen(true);
  }, []);

  const closeClaimIdFilter = useCallback(() => {
    setClaimIdFilterOpen(false);
  }, []);

  const openLawFirm = useCallback(() => {
    setLawFirmOpen(true);
  }, []);

  const closeLawFirm = useCallback(() => {
    setLawFirmOpen(false);
  }, []);

  const openLawFirm1 = useCallback(() => {
    setLawFirm1Open(true);
  }, []);

  const closeLawFirm1 = useCallback(() => {
    setLawFirm1Open(false);
  }, []);

  const openLawFirm2 = useCallback(() => {
    setLawFirm2Open(true);
  }, []);

  const closeLawFirm2 = useCallback(() => {
    setLawFirm2Open(false);
  }, []);

  const openLawFirm3 = useCallback(() => {
    setLawFirm3Open(true);
  }, []);

  const closeLawFirm3 = useCallback(() => {
    setLawFirm3Open(false);
  }, []);

  const openLawFirm4 = useCallback(() => {
    setLawFirm4Open(true);
  }, []);

  const closeLawFirm4 = useCallback(() => {
    setLawFirm4Open(false);
  }, []);

  const openLawFirm5 = useCallback(() => {
    setLawFirm5Open(true);
  }, []);

  const closeLawFirm5 = useCallback(() => {
    setLawFirm5Open(false);
  }, []);

  const openLawFirm6 = useCallback(() => {
    setLawFirm6Open(true);
  }, []);

  const closeLawFirm6 = useCallback(() => {
    setLawFirm6Open(false);
  }, []);

  const openLawFirm7 = useCallback(() => {
    setLawFirm7Open(true);
  }, []);

  const closeLawFirm7 = useCallback(() => {
    setLawFirm7Open(false);
  }, []);

  const openLawFirm8 = useCallback(() => {
    setLawFirm8Open(true);
  }, []);

  const closeLawFirm8 = useCallback(() => {
    setLawFirm8Open(false);
  }, []);

  const openLawFirm9 = useCallback(() => {
    setLawFirm9Open(true);
  }, []);

  const closeLawFirm9 = useCallback(() => {
    setLawFirm9Open(false);
  }, []);

  const navItems = [
    {
      text: "Debt collection",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "",
      icon: "assets/arrow-down.svg",
    },

    {
      text: "Outcomes & costs",
      bgColor: "bg-primary-primary-50",
      textColor: "text-neutrals-neutral-900",
      hoverBgColor: "bg-primary-primary-50",
      hoverTextColor: "text-neutrals-neutral-900",
      path: "",
      icon: "",
    },

    {
      text: "AI indicators",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/ai1",
      icon: "",
    },
  ];

  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const judgement_phase = [
    {
      id: 1,
      claimId: "001",
      status: "In progress",
      documents: "Upload document",
      action: "Contact law firm",
    },
    {
      id: 2,
      claimId: "002",
      status: "In progress",
      documents: "Upload document",
      action: "Contact law firm",
    },
    {
      id: 3,
      claimId: "003",
      status: "Not started",
      documents: "Upload document",
      action: "Contact law firm",
    },
    {
      id: 4,
      claimId: "004",
      status: "Completed",
      documents: "Upload document",
      action: "Contact law firm",
    },
    {
      id: 5,
      claimId: "005",
      status: "Completed",
      documents: "Upload document",
      action: "Contact law firm",
    },
    {
      id: 6,
      claimId: "006",
      status: "Completed",
      documents: "Upload document",
      action: "Contact law firm",
    },
    {
      id: 7,
      claimId: "007",
      status: "Completed",
      documents: "Upload document",
      action: "Contact law firm",
    },
    {
      id: 8,
      claimId: "008",
      status: "Not started",
      documents: "Upload document",
      action: "Contact law firm",
    },
    {
      id: 9,
      claimId: "009",
      status: "In progress",
      documents: "Upload document",
      action: "Contact law firm",
    },
    {
      id: 10,
      claimId: "010",
      status: "Not started",
      documents: "Upload document",
      action: "Contact law firm",
    },
  ];

  const filteredDebtors =
    activeTab === "all"
      ? judgement_phase
      : judgement_phase.filter(
          (debtor) => debtor.status.toLowerCase() === activeTab.toLowerCase()
        );

  const searchedDebtors = filteredDebtors.filter(
    (debtor) =>
      debtor.claimId.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.status.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.documents.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.action.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const statusColorMap = {
    "Not started":
      "bg-semantics-high-high-50 text-semantics-high-high-500 border-semantics-high-high-500",
    "In progress":
      "bg-semantics-moderate-moderate-50 text-semantics-moderate-moderate-500 border-semantics-moderate-moderate-500",
    Completed:
      "bg-semantics-low-low-50 text-semantics-low-low-500 border-semantics-low-low-500",
  };

  const statusIconMap = {
    "Not started": "•",
    "In progress": "•",
    Completed: "•",
  };

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-sm text-neutrals-neutral-300 font-open-sans-ff-meta-link">
        <NavigationPanel navItems={navItems} />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-6 text-neutrals-neutral-900 px-4 md:px-4 lg:px-24 box-border">
          {/* Heading */}
          <b className="self-stretch relative text-9xl">{`Outcomes & costs`}</b>

          {/* Tabs */}
          <div className="flex flex-row items-start justify-start gap-6 text-base">
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickOutcomeUpdates}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Outcome updates</div>
              </div>
            </div>
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickCostImplications}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Cost implications</div>
              </div>
            </div>
            <div className="bg-neutrals-neutral-50 box-border h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 text-primary-primary-500 border-b-[2px] border-solid border-primary-primary-500">
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Judgement phase</div>
              </div>
            </div>
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickClientCommunication}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">
                  Client communication
                </div>
              </div>
            </div>
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickReportAndAnalytics}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">
                  Reporting & analytics
                </div>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] flex flex-col items-start justify-start text-sm">
            <div className="w-full rounded-t-3xs rounded-b-none box-border flex flex-row items-center justify-between py-5 px-6 text-lg border-t-[1px] border-solid border-neutrals-neutral-100 border-r-[1px] border-l-[1px]">
              <div className="flex flex-row items-center justify-start gap-[10px]">
                <div className="relative font-semibold">
                  Transition to judgement phase
                </div>
                <div className="rounded-[5px] bg-neutrals-neutral-50 flex flex-row items-center justify-start py-0.5 px-2 gap-[6px] text-sm border-[1px] border-solid border-neutrals-neutral-100">
                  <div className="w-1.5 relative rounded-[50%] bg-primary-primary-500 h-1.5" />
                  <div className="relative font-semibold">10 claims</div>
                </div>
              </div>
              <CTAs
                type="Secondarybtn"
                text="Download"
                borderColor="border-neutrals-neutral-100"
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M9 11v6l2-2M9 17l-2-2"
                      stroke="#2d404e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M22 10v5c0 5-2 7-7 7H9c-5 0-7-2-7-7V9c0-5 2-7 7-7h5"
                      stroke="#2d404e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M22 10h-4c-3 0-4-1-4-4V2l8 8Z"
                      stroke="#2d404e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                }
                position="relative"
                onClick={openDownloadModalTables}
              />
            </div>
            <div className="w-full box-border flex flex-row items-center justify-between py-3 px-6 border-t-[1px] border-solid border-neutrals-neutral-100 border-r-[1px] border-l-[1px]">
              <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-start border-[1px] border-solid border-neutrals-neutral-100">
                <button
                  onClick={() => setActiveTab("all")}
                  className={`rounded-tl-3xs rounded-tr-none rounded-br-none rounded-bl-3xs px-4 py-2 text-sm font-medium rounded-md  bg-column-bg flex flex-row items-center justify-center border-r-[1px] border-solid border-neutrals-neutral-100 ${
                    activeTab === "all"
                      ? "bg-neutrals-neutral-50"
                      : "text-neutrals-neutral-900 hover:bg-column-bg"
                  }`}
                >
                  <div className="relative font-semibold">View all</div>
                </button>
                <button
                  className={`flex flex-row items-center justify-center py-2 px-4 border-r-[1px] border-solid border-neutrals-neutral-100 bg-neutrals-neutral-50 ${
                    activeTab === "In progress"
                      ? "bg-neutrals-neutral-50"
                      : "text-neutrals-neutral-900 hover:bg-column-bg"
                  }`}
                  onClick={() => setActiveTab("In progress")}
                >
                  <div className="relative font-semibold">In progress</div>
                </button>
                <button
                  className={`flex flex-row items-center justify-center py-2 px-4 border-r-[1px] border-solid border-neutrals-neutral-100 bg-neutrals-neutral-50 ${
                    activeTab === "Not started"
                      ? "bg-neutrals-neutral-50"
                      : "text-neutrals-neutral-900 hover:bg-column-bg"
                  }`}
                  onClick={() => setActiveTab("Not started")}
                >
                  <div className="relative font-semibold">Not started</div>
                </button>
                <button
                  className={`rounded-tl-none rounded-tr-3xs rounded-br-3xs rounded-bl-none flex flex-row items-center justify-center py-2 px-4 bg-neutrals-neutral-50 ${
                    activeTab === "Completed"
                      ? "bg-neutrals-neutral-50"
                      : "text-neutrals-neutral-900 hover:bg-column-bg"
                  }`}
                  onClick={() => setActiveTab("Completed")}
                >
                  <div className="relative font-semibold">Completed</div>
                </button>
              </div>
              <div className="flex flex-row items-start justify-start gap-[10px] text-neutrals-neutral-300">
                <div className="w-[294px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border flex flex-row items-center justify-start py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                  <div className="flex flex-row items-center justify-start gap-[10px]">
                    <img
                      className="w-5 relative h-5"
                      alt=""
                      src="assets/search.svg"
                    />
                    <div className="relative">Search your claims</div>
                  </div>
                </div>
                <CTAs
                  type="Secondarybtn"
                  text="Filter"
                  borderColor="border-neutrals-neutral-100"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M3 7h18M6 12h12M10 17h4"
                        stroke="#2d404e"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      ></path>
                    </svg>
                  }
                  position="relative"
                  onClick={openClaimIdFilter}
                />
              </div>
            </div>
            <div className="w-full flex flex-col items-start justify-start">
              <div className="w-full flex flex-col items-start justify-start">
                <table className="min-w-full divide-y divide-gray-200 border-collapse">
                  <thead className="bg-column-bg">
                    <tr>
                      <th
                        scope="col"
                        className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-l-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                      >
                        Claim id
                      </th>
                      <th
                        scope="col"
                        className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                      >
                        Documents
                      </th>
                      <th
                        scope="col"
                        className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-r-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-neutrals-neutral-50 divide-y divide-gray-200">
                    {searchedDebtors.map((judgement_phase) => (
                      <tr key={judgement_phase.id} className="hover:bg-gray">
                        <td className="p-4 items-start border-solid border-b-[1px] border-l-[1px] border-neutrals-neutral-100">
                          {judgement_phase.claimId}
                        </td>
                        <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100 whitespace-nowrap">
                          <span
                            className={`px-2 py-0.5 text-xs font-semibold rounded-full border-solid border-[1px] border-current ${
                              statusColorMap[judgement_phase.status]
                            }`}
                          >
                            <span className="mr-1">
                              {statusIconMap[judgement_phase.status]}
                            </span>
                            {judgement_phase.status}
                          </span>
                        </td>
                        <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                          {judgement_phase.documents === "Upload document" ? (
                            <a
                              className="bg-neutrals-neutral-50 text-primary-primary-500 font-medium"
                              href="#"
                              onClick={openLawFirm}
                            >
                              Upload document
                            </a>
                          ) : (
                            judgement_phase.documents
                          )}
                        </td>
                        <td className="p-4 items-start border-solid border-b-[1px] border-r-[1px] border-neutrals-neutral-100">
                          {judgement_phase.action === "Contact law firm" ? (
                            <a
                              className="bg-neutrals-neutral-50 text-primary-primary-500 font-medium"
                              href="#"
                              onClick={openLawFirm}
                            >
                              Contact law firm
                            </a>
                          ) : (
                            judgement_phase.action
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Pagination */}
              <div className="w-full rounded-t-none rounded-b-3xs box-border flex flex-row items-center justify-between pt-3 px-6 pb-4 border-r-[1px] border-solid border-neutrals-neutral-100 border-b-[1px] border-l-[1px]">
                <CTAs
                  type="Secondarybtn"
                  text="Previous"
                  borderColor="border-neutrals-neutral-100"
                />
                <div className="relative">Page 1 of 10</div>
                <CTAs
                  type="Secondarybtn"
                  text="Next"
                  borderColor="border-neutrals-neutral-100"
                />
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
      {isDownloadModalTablesOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeDownloadModalTables}
        >
          <DownloadModalTables onClose={closeDownloadModalTables} />
        </PortalPopup>
      )}
      {isClaimIdFilterOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeClaimIdFilter}
        >
          <ClaimIdFilter onClose={closeClaimIdFilter} />
        </PortalPopup>
      )}
      {isLawFirmOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm}
        >
          <LawFirm onClose={closeLawFirm} />
        </PortalPopup>
      )}
      {isLawFirm1Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm1}
        >
          <LawFirm onClose={closeLawFirm1} />
        </PortalPopup>
      )}
      {isLawFirm2Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm2}
        >
          <LawFirm onClose={closeLawFirm2} />
        </PortalPopup>
      )}
      {isLawFirm3Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm3}
        >
          <LawFirm onClose={closeLawFirm3} />
        </PortalPopup>
      )}
      {isLawFirm4Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm4}
        >
          <LawFirm onClose={closeLawFirm4} />
        </PortalPopup>
      )}
      {isLawFirm5Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm5}
        >
          <LawFirm onClose={closeLawFirm5} />
        </PortalPopup>
      )}
      {isLawFirm6Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm6}
        >
          <LawFirm onClose={closeLawFirm6} />
        </PortalPopup>
      )}
      {isLawFirm7Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm7}
        >
          <LawFirm onClose={closeLawFirm7} />
        </PortalPopup>
      )}
      {isLawFirm8Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm8}
        >
          <LawFirm onClose={closeLawFirm8} />
        </PortalPopup>
      )}
      {isLawFirm9Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm9}
        >
          <LawFirm onClose={closeLawFirm9} />
        </PortalPopup>
      )}
    </>
  );
};

export default OutcomeAndCostPage_3;
